import React from 'react';
import {injectIntl} from 'react-intl';
import {messages} from '../common/Translations';
import PropTypes from "prop-types";
import Select from "react-select";

class CreateCategoryForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            selection: null,
            renderError: false
        };
    }

    onRemove() {
        this.setState({selection: null});
    }

    onNameChange(event) {
        this.setState({name: event.target.value});
        if (event.target.value !== '') {
            this.props.onNameChange(event.target.value);
        }
    }

    onSelect(params) {
        if (params !== null && params.value !== null) {
            this.props.onCategorySelected(params.value);
            this.setState({parentCategoryId: params.value, selection: params.value});
        } else {
            this.props.onCategorySelected(null);
            this.setState({selection: null});
        }
    }

    renderError() {
        if (this.state.name === '') {
            let hint = '';
            if (this.props.dataTypeName == 'category') {
                hint = this.props.intl.formatMessage(messages.categoriesWebmasterCreateFormInputHint);
            } else if (this.props.dataTypeName == 'competence') {
                hint = this.props.intl.formatMessage(messages.competenciesWebmasterCreateFormInputHint);
            }
            return (
                <div className={'col form-control-feedback error-block has-danger'}>
                    {hint}
                </div>
            );
        }
    }

    render() {

        let dropdownLabel = '';
        if (this.props.dataTypeName == 'category') {
            dropdownLabel = this.props.intl.formatMessage(messages.categoriesWebmasterCreateFormCategoriesListLabel) +
                ' ' + this.props.intl.formatMessage(messages.optional);
        } else if (this.props.dataTypeName == 'competence') {
            dropdownLabel = this.props.intl.formatMessage(messages.competenciesWebmasterCreateFormComListLabel) +
                ' ' + this.props.intl.formatMessage(messages.optional);
        }

        return (
            <form>
                <div className={`form-group row ${this.state.name === '' ? 'has-danger' : ''}`}>
                    <label className="col-sm-2 col-form-label">
                        <b>
                            {this.props.intl.formatMessage(messages.categoriesWebmasterCreateFormInputName)}
                        </b>
                    </label>
                    <input
                        className="form-control"
                        type="text"
                        name="name"
                        value={this.state.name}
                        onChange={this.onNameChange.bind(this)}
                    />
                    {this.renderError()}
                </div>
                <div className="form-group row">
                    <label className="col-sm-8 col-form-label">
                        <b>{dropdownLabel}</b>
                    </label>
                    <div className="col-sm-12 p-0">
                        <Select
                            options={formatFlatCategories(this.props.categories)}
                            value={this.state.selection}
                            onChange={this.onSelect.bind(this)}
                            placeholder="Vælg..."
                        />
                    </div>
                </div>
            </form>
        )
    }
}

CreateCategoryForm.defaultProps = {
    categories: []
};

CreateCategoryForm.propTypes = {
    categories: PropTypes.array,
};

function formatFlatCategories(categories) {
    return categories.map(item => {
        return {
            value: item.id,
            label: item.title,
        }
    });
}

export default injectIntl(CreateCategoryForm);


// WEBPACK FOOTER //
// ./web/src/components/categories/CreateCategoryForm.jsx